import { render } from "./AccountChangePassword.vue?vue&type=template&id=e067f8fc"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__